<template>
  <Card style="height: 100%">
    <template v-slot:title>Comprador</template>
    <template v-slot:content>
      <AppForm>
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col-12 p-lg-6">
            <AppFormItem label="Nome">
              <InputText :disabled="true" v-model="name" />
            </AppFormItem>
          </div>
          <div class="p-field p-col-12 p-md-6">
            <AppFormItem label="Documento">
              <InputText
                :disabled="true"
                v-model="document"
                v-mask="['###.###.###-##', '##.###.###/####-##']"
              />
            </AppFormItem>
          </div>
          <div class="p-field p-col-12 p-md-6">
            <AppFormItem label="Data de nascimento">
              <Calendar
                :disabled="true"
                v-model="birthDate"
                dateFormat="dd/mm/yy"
                showIcon
              />
            </AppFormItem>
          </div>
          <div class="p-field p-col-12 p-md-6">
            <AppFormItem label="Telefone">
              <InputText
                :disabled="true"
                v-model="phone"
                v-mask="'(##) ####-####'"
              />
            </AppFormItem>
          </div>
          <div class="p-field p-col-12 p-md-6">
            <AppFormItem label="Celular">
              <InputText
                :disabled="true"
                v-model="cellPhone"
                v-mask="'(##) #####-####'"
              />
            </AppFormItem>
          </div>
          <div class="p-field p-col-12 p-md-6">
            <AppFormItem label="Email">
              <InputText :disabled="true" v-model="email" />
            </AppFormItem>
          </div>
          <div class="p-field p-col-12">
            <AppFormItem label="Endereço">
              <Textarea
                :disabled="true"
                v-model="addressText"
                rows="3"
                style="resize: none"
              />
            </AppFormItem>
          </div>
        </div>
      </AppForm>
    </template>
  </Card>
</template>

<script>
import { mapFields } from 'vuex-map-fields';

export default {
  name: 'SaleEditReviewBuyer',
  computed: {
    ...mapFields('sale', [
      'formData.buyer.name',
      'formData.buyer.document',
      'formData.buyer.birthDate',
      'formData.buyer.phone',
      'formData.buyer.cellPhone',
      'formData.buyer.email',
      'formData.buyer.address',
    ]),
    ...mapFields('app', ['user']),
    addressText() {
      const { address, district, city, state, zipCode } = this.address;
      const number = this.address.number ? `, ${this.address.number}` : '';
      return `${address}${number} - ${district}, ${city} - ${state}, ${zipCode}`;
    },
  },
};
</script>

<style>
</style>